import { render } from "./ShiftSmallSlot.vue?vue&type=template&id=6fa0238e&scoped=true"
import script from "./ShiftSmallSlot.vue?vue&type=script&lang=js"
export * from "./ShiftSmallSlot.vue?vue&type=script&lang=js"

import "./ShiftSmallSlot.vue?vue&type=style&index=0&id=6fa0238e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa0238e"]])

export default __exports__